export default __webpack_public_path__ + "atomic/_patterns/01-atoms/search-icon/_search-icon.twig";